import { render, staticRenderFns } from "./PageName.vue?vue&type=template&id=79a27570"
import script from "./PageName.vue?vue&type=script&lang=js"
export * from "./PageName.vue?vue&type=script&lang=js"
import style0 from "./PageName.vue?vue&type=style&index=0&id=79a27570&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports